import {SidebarMenuItem} from "../../model/sidebar-menu-item";
import books from '../../assets/books.svg';
import workspace from '../../assets/workspace.svg';
import factory from '../../assets/factory.svg';
import statistics from '../../assets/statistics.svg';
import community from '../../assets/community.svg';
import resource from '../../assets/resource.svg';

export const SIDEBAR_MENU_ITEMS: SidebarMenuItem[] = [
    {
        titre: 'Mon espace',
        url: 'https://1001parcours.cci.fr/experience/totara/dashboard/index.php',
        icon: factory,
        authorized: [
            {role: 'administrateur', statut: 'cotisant'},
            {role: 'administrateur', statut: 'payant'},
            {role: 'administrateur', statut: 'externe'},
            {role: 'gestionnaire', statut: 'cotisant'},
            {role: 'gestionnaire', statut: 'payant'},
            {role: 'gestionnaire', statut: 'externe'},
            {role: 'contributeur', statut: 'cotisant'},
            {role: 'contributeur', statut: 'payant'},
            {role: 'contributeur', statut: 'externe'},
            {role: 'formateur', statut: 'cotisant'},
            {role: 'formateur', statut: 'payant'},
            {role: 'formateur', statut: 'externe'},
            {role: 'apprenant', statut: 'payant'},
        ]
    },
    {
        titre: '1001 Communautés',
        url: 'https://1001parcours.cci.fr/experience/totara/dashboard/index.php?id=8',
        icon: community,
        authorized: [
            {role: 'administrateur', statut: 'cotisant'},
            {role: 'administrateur', statut: 'payant'},
            {role: 'administrateur', statut: 'externe'},
            {role: 'gestionnaire', statut: 'cotisant'},
            {role: 'gestionnaire', statut: 'payant'},
            {role: 'gestionnaire', statut: 'externe'},
            {role: 'contributeur', statut: 'cotisant'},
            {role: 'contributeur', statut: 'payant'},
            {role: 'contributeur', statut: 'externe'},
            {role: 'formateur', statut: 'cotisant'},
            {role: 'formateur', statut: 'payant'},
            {role: 'formateur', statut: 'externe'}
        ]
    },
    {
        titre: '1001 Outils',
        url: 'https://1001parcours.cci.fr/1001-outils/',
        icon: workspace,
        authorized: [
            {role: 'administrateur', statut: 'freemium'},
            {role: 'administrateur', statut: 'payant'},
            {role: 'gestionnaire', statut: 'freemium'},
            {role: 'gestionnaire', statut: 'payant'},
            {role: 'contributeur', statut: 'freemium'},
            {role: 'contributeur', statut: 'payant'},
            {role: 'formateur', statut: 'freemium'},
            {role: 'formateur', statut: 'payant'},
        ]
    },
    {
        titre: '1001 Ressources',
        url: 'https://1001parcours.cci.fr/1001ressources',
        icon: resource,
        authorized: [
            {role: 'administrateur', statut: 'freemium'},
            {role: 'administrateur', statut: 'payant'},
            {role: 'gestionnaire', statut: 'freemium'},
            {role: 'gestionnaire', statut: 'payant'},
            {role: 'contributeur', statut: 'freemium'},
            {role: 'contributeur', statut: 'payant'},
            {role: 'formateur', statut: 'freemium'},
            {role: 'formateur', statut: 'payant'}
        ]
    },
    {
        titre: 'Me tester',
        url: 'https://1001parcours.cci.fr/level/dashboard',
        icon: statistics,
        authorized: [
            {role: 'administrateur', statut: 'cotisant'},
            {role: 'administrateur', statut: 'payant'},
            {role: 'administrateur', statut: 'externe'},
            {role: 'gestionnaire', statut: 'cotisant'},
            {role: 'gestionnaire', statut: 'payant'},
            {role: 'gestionnaire', statut: 'externe'},
            {role: 'contributeur', statut: 'cotisant'},
            {role: 'contributeur', statut: 'payant'},
            {role: 'contributeur', statut: 'externe'},
            {role: 'formateur', statut: 'cotisant'},
            {role: 'formateur', statut: 'payant'},
            {role: 'formateur', statut: 'externe'},
            {role: 'apprenant', statut: 'freemium'},
            {role: 'apprenant', statut: 'payant'},
            {role: 'apprenant', statut: 'externe'},
            {role: 'candidat', statut: 'freemium'},
            {role: 'candidat', statut: 'payant'},
            {role: 'candidat', statut: 'externe'},
        ]
    },
    {
        titre: 'Aide',
        url: 'https://1001parcours.cci.fr/fr/aide',
        icon: books,
        authorized: [
            {role: 'administrateur', statut: 'cotisant'},
            {role: 'administrateur', statut: 'payant'},
            {role: 'gestionnaire', statut: 'cotisant'},
            {role: 'gestionnaire', statut: 'payant'},
            {role: 'contributeur', statut: 'cotisant'},
            {role: 'contributeur', statut: 'payant'},
            {role: 'formateur', statut: 'cotisant'},
            {role: 'formateur', statut: 'payant'},
            {role: 'apprenant', statut: 'payant'},
        ]
    },
    {
        titre: 'Aide',
        url: 'https://1001parcours.cci.fr/experience/mod/page/view.php?id=71',
        icon: books,
        authorized: [
            {role: 'administrateur', statut: 'externe'},
            {role: 'gestionnaire', statut: 'externe'},
            {role: 'contributeur', statut: 'externe'},
            {role: 'formateur', statut: 'externe'},
        ]
    },
    {
        titre: 'Aide',
        url: 'https://1001parcours.cci.fr/experience/mod/page/view.php?id=69',
        icon: books,
        authorized: [
            {role: 'apprenant', statut: 'externe'},
            {role: 'candidat', statut: 'externe'},
        ]
    },
    {
        titre: 'Annuaire',
        url: 'https://1001parcours.cci.fr/fr/annuaire',
        icon: community,
        authorized: [
            {role: 'administrateur', excludedStatut: 'externe'},
            {role: 'gestionnaire', excludedStatut: 'externe'},
            {role: 'contributeur', excludedStatut: 'externe'},
            {role: 'formateur', excludedStatut: 'externe'},
        ]
    },
]
